module.exports = __webpack_public_path__ + "img/pic13.a7097fa7.jpg";